module.exports = __webpack_public_path__ + "img/axa.5315e038.png";